module.exports = __webpack_public_path__ + "img/Sunglasses03.4bbff407.png";